// This function allow to reference async chunks
__webpack_require__.k = (chunkId) => ("style/" + "5973e2e0e8ed1acd" + ".css");